/* eslint-disable */
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
function App() {
  return (
    <BrowserRouter>
      <MyComponent />
    </BrowserRouter>
  );
}

function MyComponent() {
 

  return (
    <div className={`w-full `}>
      <Routes>
        
        <Route path={"*"} element={<NotFound />} />

        <Route path="/" element={<Home />} />
      </Routes>
    </div>
  );
}



export default App;
